<template>
  <v-container fluid pa-4 ma-0>
    <PageHeader :title="user.displayName" subtitle="Edit your profile"></PageHeader>
    <v-container
      id="useredit-main" pa-0 fluid
      class="elevation-2 rounded-3"
      style="background-color:white">
      <v-flex>
        <v-tabs id="useredit-tabs" show-arrows color="white" slider-color="primary" grow>
          <v-tab
            ripple v-for="item in items" :key="item.name"
            @click="handleClick(item)">
            {{item.name}}
          </v-tab>
          <v-tab-item v-for="item in items" :key="item.name+'-content'">
            <v-divider></v-divider>
            <v-container fluid>
              <Loading :isLoading="currentUserLoading">
                <v-layout row wrap>
                  <v-flex xs12 px-4 py-3 mb-3>
                    <div id="user edit details">
                      <component
                        v-on:userUpdate="toggleChangesMade()"
                        v-on:passUpdate="passwordChanged=true"
                        v-on:mfaUpdate="mfaChanged=true"
                        v-on:toggleMFA="toggleMFA()"
                        :configMode="false"
                        :is="item.component"/>
                    </div>
                  </v-flex>
                </v-layout>
              </Loading>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-dialog v-model="ShowSaveUserDialog" width="400" persistent id="useredit-save-dialog">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>Update your profile</h2>
          </v-card-title>
          <v-card-text class="pa-0">
            <p>Are you sure you want to save these changes?</p>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn
              @click="updateUser()"
              id="useredit-save-dialog-save-btn"
              color="success">
              OK
            </v-btn>
            <v-btn
              id="useredit-save-dialog-cancel-btn"
              @click="cancelEdit()"
              color="error">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn
        class="mt-4 mb-0 mx-0" color="success"
        :disabled="!changesMade && !mfaChanged && !mfaDisabled"
        @click="ShowSaveUserDialog = true">
        Save Changes
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import PageHeader from "@/components/PageHeader.vue"
import UserEditDetails from "@/components/Users/UserEdit/UserEditDetails.vue"
import UserEditPassword from "@/components/Users/UserEdit/UserEditPassword.vue"
import UserEditMFA from "@/components/Users/UserEdit/UserEditMFA.vue"
import Loading from "@/components/shared/Loading.vue"

export default {
  name: "user-profile",
  components: {
    UserEditDetails,
    UserEditPassword,
    UserEditMFA,
    Loading,
    PageHeader
  },
  data: () => ({
    changesMade: false,
    passwordChanged: false,
    mfaChanged: false,
    mfaDisabled: false,
    ShowSaveUserDialog: false,
    tabModel: 0,
    localUpdate: false
  }),
  watch: {
    userTab() { this.handleRouteChange(this.userTab) }
  },
  computed: {
    ...mapState({
      userTab: state => state.cbroute.params.userTab,
      currentUserLoading: state => state.ui.loadingSelectedUser,
      user: state => state.users.currentlySelected.user,
      currentUser: state => state.currentUser
    }),
    items() {
      return [
        { name: "Profile", title: "User Profile", component: "UserEditDetails" },
        { name: "Password", title: "User Password", component: "UserEditPassword" },
        { name: "MFA", title: "Multifactor Authentication", component: "UserEditMFA" }
      ]
    }
  },
  methods: {
    toggleMFA() {
      this.mfaDisabled = !this.mfaDisabled
    },
    toggleChangesMade() {
      this.changesMade=true
    },
    checkSaveDialog() {
      this.ShowSaveUserDialog = this.changesMade || this.mfaChanged || this.mfaDisabled
    },
    handleClick(item) {
      this.localUpdate = true
      this.$router.push({ path: item.name })
    },
    handleRouteChange(route) {
      if (!this.localUpdate) {
        switch (route) {
          case "password":
            this.tabModel = 1
            break
          default:
            this.tabModel = 0
        }
      }
      this.localUpdate = false
    },
    async updateUser() {
      this.ShowSaveUserDialog = false
      let result = { error: false }

      if (this.mfaChanged) {
        result = await this.$store.dispatch("setupMFA", this.user)
      }

      if (this.mfaDisabled) {
        result = await this.$store.dispatch("disableMFA", this.user)
      }

      if (!result.error && this.passwordChanged) {
        result = await this.$store.dispatch("updateUserWithPassword", this.user)
      } else if (!result.error && this.changesMade) {
        result = await this.$store.dispatch("updateUser", this.user)
      }
      if (!result.error) {
        this.passwordChanged = false
        this.changesMade = false
        this.mfaChanged = false
        this.returnToHome()
      }
    },
    cancelEdit() {
      this.ShowSaveUserDialog = false
    },
    returnToHome() {
      this.$router.push({ name: "Dashboard", params: { section: 'overview' } }).catch(() => {})
    }
  }
}
</script>
